import { faCircleMinus } from "@fortawesome/free-solid-svg-icons";
import React, { type FC, useRef } from "react";
import { useApiCall } from "../api/api";
import { type Company, User } from "../api/dto";
import { ModalFooter } from "../components/layout/ModalProvider";
import { useRefresh } from "../components/RefreshController";

export const RevokeCompanyAccessModal: FC<{
  company: Company;
  userId: string;
  onFinished?: () => void;
}> = (props) => {
  const { revokeCompanyAccessFromUser } = useApiCall();
  const refresh = useRefresh();

  const save = async () => {
    await revokeCompanyAccessFromUser(props.userId, props.company.id);
    refresh();
  };
  return (
    <div>
      <p>
        <strong>Let op!</strong> Weet je zeker dat deze gebruiker toegang wilt ontzeggen tot{" "}
        <strong>{props.company.name}</strong>?
      </p>
      <p>
        Dit is een <strong>permanente</strong> actie en kan niet ongedaan worden gemaakt.
      </p>
      <ModalFooter text={"Toegang ontzeggen"} icon={faCircleMinus} onSubmit={save} />
    </div>
  );
};
